module.exports = __webpack_public_path__ + "img/slide1.25d240c4.jpg";